import { useEffect, useState } from 'react'

import { AdasBox } from '@components/wrapper-components'
import { useNotificationSubscription } from '@hooks/useNotificationSubscription'
import { useAuthStore } from '@caradasstore/AuthStore'
import { useCenterStore } from '@caradasstore/CenterStore'
import { useBroadcastStore } from '@caradasstore/BroadcastStore'
import { useUserStore } from '@caradasstore/UserStore'
import { getActiveBroadcast } from 'api/api'
import { emailFromAuthToken } from '../../utils/utils'
import { BroadcastBanner } from './BroadcastBanner'
import { getBroadcastKey, isBroadcastDismissed, rememberBroadcastDismissed } from './broadcastDismissal'

export const BroadcastBar = () => {
  const centerDetail = useCenterStore((store) => store.centerDetail)
  const broadcastmessage = useBroadcastStore((store) => store.broadCastMessage)
  const setBroadcastMessage = useBroadcastStore((store) => store.setBroadcastMessage)
  // The sign-in token is the identity: UserStore.userEmail is not filled on every sign-in path (CAR-4102).
  const token = useAuthStore((store) => store.token)
  const storedEmail = useUserStore((store) => store.userEmail)
  const userEmail = emailFromAuthToken(token) || storedEmail || ''
  // Hides the banner straight away on Dismiss; the stored copy keeps it hidden after a refresh or re-fetch.
  const [dismissedKey, setDismissedKey] = useState(null)

  useNotificationSubscription(centerDetail?.id)

  useEffect(() => {
    const fetchData = async () => {
      try {
        const broadcastResponse = await getActiveBroadcast()
        if (broadcastResponse?.data) {
          setBroadcastMessage(broadcastResponse.data)
        } else {
          setBroadcastMessage(null)
        }
      } catch (error) {
        console.log(error)
      }
    }

    fetchData()
  }, [])

  if (!broadcastmessage?.message) return null
  const key = getBroadcastKey(broadcastmessage, userEmail)
  if (key === dismissedKey || isBroadcastDismissed(broadcastmessage, userEmail)) return null

  const dismiss = () => {
    rememberBroadcastDismissed(broadcastmessage, userEmail)
    setDismissedKey(key)
  }

  return (
    // Same column as the page content (and the billing status bar), so it lines up with the page below.
    <AdasBox className='px-3 min-[435px]:px-6 mx-auto w-full max-w-[1400px] mt-4'>
      <BroadcastBanner
        type={broadcastmessage.type}
        subject={broadcastmessage.subject}
        message={broadcastmessage.message}
        onDismiss={dismiss}
      />
    </AdasBox>
  )
}
